<template>
  <router-view :key="$route.params.id" />
</template>

<script>
export default {
  name: 'LeadsDetailIndex'
}
</script>
